import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import {
    MyTimesheetEntryWorkTypeId,
    MyTimesheetEntryWorkTypeName,
    MyTimesheetEntriesProps
} from 'services/myTimesheetEntries/types';

// Global Components
// @ts-ignore
import WorkTypeName from 'components/WorkTypeName';

// Global Selectors
import {
    makeSelectMyTimesheetEntryWorkTypeId,
    makeSelectMyTimesheetEntryWorkTypeName
} from 'services/myTimesheetEntries/selectors';
import { selectCurrentMyTimesheetIsEditable } from 'services/myTimesheets/selectors';

type OwnProps = MyTimesheetEntriesProps;

interface ConnectedProps {
    currentMyTimesheetIsEditable?: boolean | null;
    workTypeId?: MyTimesheetEntryWorkTypeId;
    workTypeName?: MyTimesheetEntryWorkTypeName;
}

type Props = OwnProps & ConnectedProps;

/**
 * Checks to see if entry is editable,
 * And if editable use the workType that exists in state,
 * And if uneditable display the values computed by the API.
 * This is done so that a workTypeName displays when an entry is created offline.
 */
export class MyTimesheetEntryWorkTypeNameValue extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | string | null {
        const {
            workTypeId,
            currentMyTimesheetIsEditable,
            workTypeName
        } = this.props;

        // If editable use the workType that exists in state
        if (currentMyTimesheetIsEditable) {
            return <WorkTypeName workTypeId={workTypeId} />;
        }

        // If uneditable display the values computed by the API
        return workTypeName || null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    currentMyTimesheetIsEditable: selectCurrentMyTimesheetIsEditable,
    workTypeId: makeSelectMyTimesheetEntryWorkTypeId(),
    workTypeName: makeSelectMyTimesheetEntryWorkTypeName()
});

export default connect(mapStateToProps)(MyTimesheetEntryWorkTypeNameValue);
